/**
 * อ่าน admin_user จาก localStorage แบบทน JSON พัง (หน้าแอดมินหลายหน้า parse เองซ้ำ ๆ)
 * root admin (admin_users) ไม่มี `type` หรือ type='admin'; employee = type='admin_employee' + permissions
 */
export interface AdminUserLite {
  type?: string;
  role?: string;
  username?: string;
  permissions?: Record<string, boolean>;
}

export const readAdminUser = (): AdminUserLite => {
  try {
    return JSON.parse(localStorage.getItem('admin_user') || '{}') || {};
  } catch {
    return {};
  }
};

export const isRootAdmin = (u: AdminUserLite): boolean => u.type !== 'admin_employee';

/** root admin ผ่านทุก permission (backend bypass เหมือนกัน) — employee ต้องมี key เป็น true */
export const hasAdminPermission = (u: AdminUserLite, key: string): boolean =>
  isRootAdmin(u) || u.permissions?.[key] === true;
